export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20fashion%20lifestyle%20composition%20with%20elegantly%20arranged%20neutral%20tone%20clothing%20and%20accessories%20on%20a%20warm%20cream%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20large%20window%2C%20curated%20selection%20of%20beige%20sneakers%20folded%20oatmeal%20hoodie%20and%20leather%20accessories%2C%20editorial%20product%20photography%20with%20gentle%20shadows%2C%20warm%20earthy%20color%20palette%2C%20harmonious%20and%20inviting%20aesthetic%2C%20high%20detail%20textures%20visible%20on%20fabrics%20and%20materials&width=1920&height=1080&seq=hero-bg-acb-2026-v6&orientation=landscape"
          alt="AllChinaBuy Spreadsheet - Best buying guide and product spreadsheet for fashion and accessories"
          title="AllChinaBuy Spreadsheet - Fashion Product Spreadsheet 2026"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center flex flex-col items-center">
        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-8">
          {['Updated Weekly', 'Quality Checked', '14 Categories', 'Trusted Sellers'].map((badge, idx) => (
            <span
              key={idx}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs md:text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-check-line text-xs text-accent-400"></i>
              {badge}
            </span>
          ))}
        </div>

        {/* H1 */}
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-4xl">
          Best AllChinaBuy Spreadsheet
          <span className="block text-accent-300 font-light italic text-2xl md:text-4xl lg:text-5xl mt-1">2026 Edition</span>
        </h1>

        {/* Subtitle */}
        <p className="mt-5 text-sm md:text-base text-background-50/80 max-w-2xl leading-relaxed">
          Discover the most comprehensive <strong>AllChinaBuy Spreadsheet</strong> with trusted sellers,
          real QC photos, organized product lists, and expert buying guides across 14 curated categories.
          Save hours of research and shop smarter.
        </p>

        {/* CTA Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
          >
            AllChinaBuy Sheet
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-background-50/25 transition-all cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-background-50/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}